var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationMarkCircleYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.667969 8.99941C0.667969 4.40024 4.4013 0.666077 9.0013 0.666077C13.6096 0.666077 17.3346 4.40024 17.3346 8.99941C17.3346 13.6002 13.6096 17.3327 9.0013 17.3327C4.4013 17.3327 0.667969 13.6002 0.667969 8.99941ZM8.26797 5.84108C8.26797 5.44191 8.6013 5.10774 9.0013 5.10774C9.4013 5.10774 9.7263 5.44191 9.7263 5.84108V9.52441C9.7263 9.92524 9.4013 10.2494 9.0013 10.2494C8.6013 10.2494 8.26797 9.92524 8.26797 9.52441V5.84108ZM9.00964 12.9002C8.6013 12.9002 8.2763 12.5669 8.2763 12.1669C8.2763 11.7669 8.6013 11.4419 9.0013 11.4419C9.40964 11.4419 9.73464 11.7669 9.73464 12.1669C9.73464 12.5669 9.40964 12.9002 9.00964 12.9002Z",
    fill: "#FFBE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMarkCircleYellow);
export default __webpack_public_path__ + "static/media/exclamation-mark-circle--yellow.d483357c68f1b9f1fbb812aa2fa12742.svg";
export { ForwardRef as ReactComponent };